module.exports = __webpack_public_path__ + "img/lci-header.4187d810.jpg";